import Vue from 'vue';
import configs from '@/configs';
import { request_header } from '@/commons/hpod';

const endpoint = `${configs.API}/api/permissions/matrix`;

function resolveToken(explicitToken) {
  if (explicitToken) {
    return explicitToken;
  }

  // 1. Check window.getApp store
  if (window.getApp && window.getApp.$store) {
    const globalState = window.getApp.$store.state;
    if (globalState && globalState.authentication && globalState.authentication.token) {
      return globalState.authentication.token;
    }
  }

  // 2. Check Vue prototype
  if (Vue.prototype.$store && Vue.prototype.$store.state && Vue.prototype.$store.state.authentication) {
    return Vue.prototype.$store.state.authentication.token;
  }

  // 3. Check localStorage directly (jwt)
  const jwt = localStorage.getItem('jwt');
  if (jwt) {
    return jwt;
  }

  // 4. Check vuex persisted state in localStorage
  try {
    const vuexCached = localStorage.getItem('vuex');
    if (vuexCached) {
      const parsedVuex = JSON.parse(vuexCached);
      if (parsedVuex && parsedVuex.authentication && parsedVuex.authentication.token) {
        return parsedVuex.authentication.token;
      }
    }
  } catch (error) {
    console.warn('Không thể đọc token từ localStorage (vuex)', error);
  }

  try {
    const cached = localStorage.getItem('authentication');
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed && parsed.token) {
        return parsed.token;
      }
    }
  } catch (error) {
    console.warn('Không thể đọc token từ localStorage', error);
  }

  return null;
}

export function getPermissionMatrix(token) {
  const authToken = resolveToken(token);
  if (!authToken) {
    return Promise.reject(new Error('Thiếu token đăng nhập để tải phân quyền.'));
  }
  return Vue.http.get(endpoint, {
    headers: request_header(authToken)
  });
}

export function savePermissionMatrix(matrix, token) {
  const authToken = resolveToken(token);
  if (!authToken) {
    return Promise.reject(new Error('Thiếu token đăng nhập để lưu phân quyền.'));
  }
  return Vue.http.post(endpoint, { matrix }, {
    headers: request_header(authToken)
  });
}
